/**
 * Connector Field Default Configuration
 *
 * Field for connecting to external data sources or related items.
 * Properties aligned with API JSON configuration structure.
 */

export interface ConnectorFieldConfig {
  label: string;
  showTitle: boolean;
  exclusionType: 'hide' | 'disable';
  displayName: string;
  shortDisplayName?: string;
  required: boolean;
  connectorType: string;
}

export const CONNECTOR_DEFAULT_CONFIG: Omit<ConnectorFieldConfig, 'label' | 'displayName'> = {
  showTitle: true,
  exclusionType: 'hide',
  shortDisplayName: '',
  required: false,
  connectorType: 'standard',
};

/**
 * Create default configuration for a connector field
 * @param fieldName The field name to use as label
 */
export const createConnectorConfig = (fieldName: string): ConnectorFieldConfig => ({
  ...CONNECTOR_DEFAULT_CONFIG,
  label: fieldName,
  displayName: '',
});

export default createConnectorConfig;
